(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["kuml-portal-web"] = factory();
	else
		root["kuml-portal-web"] = factory();
})(globalThis, () => {
return 